const { protocol, hostname, port } = window.location;
const isFrontendDevServer = port === '3000';
export const API_BASE_URL = isFrontendDevServer ? `${protocol}//${hostname}:5000` : '';
